import { render, staticRenderFns } from "./FooterNav.vue?vue&type=template&id=4a4a1006&"
import script from "./FooterNav.vue?vue&type=script&lang=ts&"
export * from "./FooterNav.vue?vue&type=script&lang=ts&"
import style0 from "./FooterNav.vue?vue&type=style&index=0&id=4a4a1006&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports